import React, { useEffect, useState } from "react";
import { Box, Button, IconButton, useTheme } from "@mui/material";
import { DataGrid } from "@mui/x-data-grid";
import { tokens } from "c:/Users/imana/Downloads/react-admin-dashboard-master/src/theme";
import Header from "c:/Users/imana/Downloads/react-admin-dashboard-master/src/components/Header";
import EditIcon from "@mui/icons-material/Edit";
import axiosInstance from "../../axiosInstance";

const CourseCategories = () => {
  const theme = useTheme();
  const colors = tokens(theme.palette.mode);
  const [categories, setCategories] = useState([]);

  // Fetch course categories
  const fetchCategories = () => {
    axiosInstance
      .get("/courses/categories")
      .then((res) => setCategories(res.data))
      .catch((err) => console.error(err));
  };

  useEffect(() => {
    fetchCategories();
  }, []);

  const columns = [
    { field: "id", headerName: "ID", width: 70 },
    { field: "name", headerName: "Category Name", flex: 1 },
  ];

  return (
    <Box m="20px">
      <Header
        title="COURSE CATEGORIES"
        subtitle="List of all course categories"
      />
      {/* Add New Category Button */}
      <Box
        m="0"
        height="75vh"
        sx={{
          "& .MuiDataGrid-root": { border: "none" },
          "& .MuiDataGrid-cell": { borderBottom: "none" },
          "& .MuiDataGrid-columnHeaders": {
            backgroundColor: colors.blueAccent[700],
            borderBottom: "none",
          },
          "& .MuiDataGrid-virtualScroller": {
            backgroundColor: colors.primary[400],
          },
          "& .MuiDataGrid-footerContainer": {
            borderTop: "none",
            backgroundColor: colors.blueAccent[700],
          },
        }}
      >
        <DataGrid
          rows={categories}
          columns={columns}
          pageSize={10}
          rowsPerPageOptions={[5, 10, 20, 50]}
        />
      </Box>
    </Box>
  );
};

export default CourseCategories;
